import styled from 'styled-components';
import Ico24 from 'dc/Ico24';
import TxtField01 from 'dc/TxtField01';
import TxtField02 from 'dc/TxtField02';
import { Typ30, Typ31, Typ41 } from 'dc/Typ';
import Btn021 from 'dc/Btn021';
import Btn020 from 'dc/Btn020';
import SpaHR03 from 'dc/SpaHR03';

export const Container = styled.div`
  width: 458px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

export const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 5px;
  width: 100%;
  margin-top: 50px;
  padding: 56px 85px 68px 85px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Title = styled(Typ41)`
  color: #004750;
  margin-bottom: 32px;
`;

export const Form = styled.form`
  text-align: center;
  width: 288px;
`;

export const Input = styled(TxtField01)`
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #f4f7f9 inset !important;
  }
  input {
    background: #fff;
  }
`;

export const PasswordInput = styled(TxtField02)`
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px #f4f7f9 inset !important;
  }
  input {
    background: #fff;
  }
`;

export const TermsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 6px;
  margin-bottom: 30px;
`;

export const TermsIcon = styled(Ico24)`
  color: #007079;
  margin-right: 6px;
  cursor: pointer;
`;

export const TermsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  text-align: left;
`;

export const TermsText = styled(Typ30)`
  color: #273238;
`;

export const TermsLink = styled(Typ31)`
  color: #007079;
  text-decoration: underline;
  cursor: pointer;
  word-break: break-all;
`;

export const RegisterButton = styled(Btn021)`
  width: 100%;
  background-color: #007079;
`;

export const LoginWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  background-color: transparent;
`;

export const NewUserText = styled(Typ30)`
  color: rgba(38, 50, 56, 0.7);
  max-width: 180px;
`;

export const LoginButton = styled(Btn020)`
  background-color: transparent;
  border: 0;
  > span {
    color: #007079;
  }
`;

export const SpacerLine = styled(SpaHR03)`
  width: 288px;
`;

export const OtherButton = styled(Btn020)`
  margin-top: 22px;
  margin-bottom: 32px;
  width: 288px;
  height: 48px;
  span {
    display: inline-block;
    color: #007079;
    text-decoration: underline;
    text-transform: lowercase;
    font-size: 14px;
    line-height: 21px;
  }
  span:first-letter {
    text-transform: capitalize;
  }
`;
